import {
  cellMenuItemCollapseAllRows,
  cellMenuItemCollapseRow,
  cellMenuItemRemoveRow,
  cellMenuItemToggleArchiveRow,
} from "../utils/gridCellMenuUtils.jsx";
import { SWIVU_GROUP_CONTEXT_MENU_SELECTOR } from "./OtherKeys.jsx";
import { INCENTIVE_POINT_COLUMNS } from "./IncentivePointColumns.jsx";
import { cellAvatarTooltipConfig, generateMultiFilterConfigFromModel } from "../utils/utils.jsx";
import { IncentivePoint } from "../../bryntum-lib/models/IncentivePoint.jsx";
import { INCENTIVE_POINT_STATUS_VALUES } from "./IncentiveKeys.jsx";

export const INCENTIVE_POINTS_FILTER_FIELD_CONFIG = {
  ...generateMultiFilterConfigFromModel(IncentivePoint),
  taskName: { type: "string" },
  incentiveType: { type: "string" },
  incentiveStatus: { type: "string" },
  incentiveName: { type: "string" },
  boardUserName: { type: "_swivu_settings" },
  "pointTagRecord.name": { type: "string" },
};

const INCENTIVE_POINTS_GRID_CONFIG = {
  columns: INCENTIVE_POINT_COLUMNS,
  preserveScrollOnDatasetChange: true,
  cls: "swivu-incentive-points-grid",
  filterFeature: {
    pickerConfig: {
      fields: INCENTIVE_POINTS_FILTER_FIELD_CONFIG
    },
    closeEmptyPopup: true
  },
  statefulEvents: [
    "subGridCollapse",
    "subGridExpand",
    "horizontalScroll",
    "stateChange",
    "scroll"
  ],
  cellMenuFeature: {
    clickTriggerSelector: SWIVU_GROUP_CONTEXT_MENU_SELECTOR,
    items: {
      cut: false,
      copy: false,
      paste: false,
      filterStringEquals: false,
      filterDisable: false,
      filterMenu: false,
      removeRow: cellMenuItemRemoveRow(),
      archive: cellMenuItemToggleArchiveRow(),
      collapseRow: cellMenuItemCollapseRow(),
      collapseAllRows: cellMenuItemCollapseAllRows(),
      status: {
        icon: "fa-light fa-bars-progress",
        text: "Status",
        hidden: true,
        menu: {
          items: Object.entries(INCENTIVE_POINT_STATUS_VALUES).map(([key, value]) => ({
            id: Number(key),
            text: value,
            value: Number(key)
          })),
        }
      }
    },
  },
  headerMenuFeature: true,
  cellTooltipFeature: cellAvatarTooltipConfig,
};

export { INCENTIVE_POINTS_GRID_CONFIG };
